import { render, staticRenderFns } from "./video_player.vue?vue&type=template&id=36751376&scoped=true&"
import script from "./video_player.vue?vue&type=script&lang=js&"
export * from "./video_player.vue?vue&type=script&lang=js&"
import style0 from "./video_player.vue?vue&type=style&index=0&id=36751376&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36751376",
  null
  
)

export default component.exports